<template>
    <div class="chatWrap chatHistoryWrap wrap">

        <div class="back">
            <button
                class="btnBack"
                @click="goBack"
                v-if="showHistory.length"
            >
				{{'components/sidebar/chat-history.back' | trans}}
            </button>
        </div>

        <div class="content">

            <h3>{{'components/sidebar/chat-history.title' | trans}}</h3>

            <div class="wrap">
                <vue-custom-scrollbar class="scrollArea">

                    <div v-if="!showHistory.length" class="chatHistory">
                        <div
                            class="block chatBox active"
                            @click="filterChatHistory(i)"
                            v-for="(msg, i) in chatHistory"
                            :key="i"
                        >
                            <div class="left">
                                <div class="icon"></div>
                                <div>
                                    <div class="titleWrap">
                                        <span class="title block">{{'components/sidebar/chat-history.your-conversation-from' | trans}} </span>
                                    </div>
                                    <span class="time">{{ formatDate(msg.time) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="showHistory.length" class="timeWrap center">
                        <span>{{ formatDateSec(showHistory[0].time) }}</span>
                    </div>

                    <div v-if="showHistory.length" class="messages">
                        <div
                            :key="index"
                            v-for="(res, index) in showHistory[0].chatData"
                            class="message"
                            :class="{ 'you' : res.user, 'chat' : !res.user }"
                        >
                            <div v-if="res.text">
                                <span>{{ res.text }}</span>
                            </div>
                        </div>
                    </div>

                 </vue-custom-scrollbar>
            </div>

        </div>

    </div>
</template>

<script>
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import moment from 'moment';
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                showHistory: []
            }
        },

        methods: {
            filterChatHistory(i) {
                return this.showHistory = [this.chatHistoryMessages[i]];
            },
            goBack() {
                this.showHistory = [];
            },
            formatDate(date) {
                return moment(date).format('DD/MM/YYYY HH:mmA');
            },
            formatDateSec(date) {
                return moment(date).calendar(moment());
            },
        },
        components : { vueCustomScrollbar },
        computed: {
            ...mapState(['chatHistory']),
            chatHistoryMessages () {
                return this.$store.getters.getChatHistory
            },
        }
    }
</script>
